.GlassReceipt {
    position: relative;
    /* Header / lines provide their own padding so the perforation can run
       edge to edge. */
    padding: 0;
    border-radius: 20px;
    overflow: visible;
}

.header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    padding: 24px 28px;
}

.headerMain {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    min-width: 0;
}

.icon {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
}

.perforation {
    position: relative;
    height: 0;
    margin: 0 16px;
    border-top: 1px dashed var(--soniq-t--global--border--color--card--default);
}

/* Ticket-style notches biting into the left and right edges. */
.perforation::before,
.perforation::after {
    content: '';
    position: absolute;
    top: 0;
    width: 18px;
    height: 18px;
    transform: translateY(-50%);
    border-radius: 50%;
    background: var(
            --soniq-t--global--background--color--primary--default
    );
}

.perforation::before {
    left: -25px;
}

.perforation::after {
    right: -25px;
}

.lines {
    margin: 0;
    padding: 8px 28px 24px;
}

.line {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 16px;
    padding: 14px 0;
    border-bottom: 1px solid var(--soniq-t--global--border--color--card--default);
}

.line:last-child {
    border-bottom: none;
}

.lineLabel {
    margin: 0;
    color: var(--soniq-t--global--text--color--body--default);
}

.lineValue {
    margin: 0;
    text-align: right;
    color: var(--soniq-t--global--text--color--body--default);
}
